<h1 mat-dialog-title class="alert-title">{{ data.alert?.title ?? "Alert Title" }}</h1>
<div mat-dialog-content class="alert-content">
 {{ data.alert?.bodyText ?? "Alert Body" }}
</div>
<div mat-dialog-actions>
  <button mat-dialog-close class="button">Got it</button>
</div>
